import { render, staticRenderFns } from "./ResourceDistribution.vue?vue&type=template&id=6a4fe37b&scoped=true"
import script from "./ResourceDistribution.vue?vue&type=script&lang=js"
export * from "./ResourceDistribution.vue?vue&type=script&lang=js"
import style0 from "./ResourceDistribution.vue?vue&type=style&index=0&id=6a4fe37b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4fe37b",
  null
  
)

export default component.exports